module.exports = __webpack_public_path__ + "static/media/form-DES.a721bf09.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/form/form-DES.pdf
// module id = 851
// module chunks = 40